import { render, staticRenderFns } from "./UtilityDetailLayout.vue?vue&type=template&id=2a7b94c0"
import script from "./UtilityDetailLayout.vue?vue&type=script&lang=js"
export * from "./UtilityDetailLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports